<template>
    <form style="width: 100%;">
        <fieldset style="margin-bottom: 20px;cursor: default;">
            <legend>
                <slot name="legend" />
            </legend>

            <table class="grid">
                <tr>
                    <td>
                        <div class="inputMarkable">
                            <input :disabled="canModify === false" type="text" v-model="item.author_name" debounce="500">
                        </div>
                    </td>
                    <td>
                        <div style="display:inline;float: right">
                            <date-picker :disableHighlighting="true" :key="status+item.id" v-model="item.created_at" format='DD.MM.YYYY HH:mm' />
                        </div>
                        <div class="direct_question_form__phone">
                            <span v-if="item.author.phone !==''">Тел: <b>{{ item.author.phone | formatPhone }}</b></span>
                        </div>
                        <div class="direct_question_form__phone">
                            <span v-if="item.author.name !=='' && item.author.name !== item.author_name">Имя: <b>{{ item.author.name }}</b></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td valign="top" colspan="2">
                            <label class="nomark">Вопрос</label>
                            <div class="textareaMarkable">
                                <textarea :disabled="canModify === false"  v-model="item.text" v-autoexpand v-beautify.literal="textareaFilters" rows="1"></textarea>
                            </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div v-if="item.moderated_at != null">
                            <small>Проверено: <b>{{ item.moderated_at | formatDateTime }}</b></small>
                            <br />
                            <small>Проверил: <b>{{ item.moderator.fio }}</b></small>
                        </div>
                    </td>
                    <td>
                        <div class="controls nomark" style="float: right" v-if="canModify">
                            <v-loading-component v-if="status !== 'new'" @click="update(item, $event)">
                                <template slot-scope="{ loadingClass }">
                                    <button :class="['blueHover', loadingClass]">Сохранить</button>
                                </template>
                            </v-loading-component>
                            <v-loading-component v-if="status !== 'published'" @click="publish(item, $event)">
                                <template slot-scope="{ loadingClass }">
                                    <button :class="['greenHover', loadingClass]">Публиковать</button>
                                </template>
                            </v-loading-component>
                            <v-loading-component v-if="status  !== 'unpublished'" @click="unPublish(item, $event)">
                                <template slot-scope="{ loadingClass }">
                                    <button :class="['redHover', loadingClass]">{{ status  === 'new' ? 'Не публиковать' : 'Отменить публикацию' }}</button>
                                </template>
                            </v-loading-component>

                            <v-loading-component @click="deleteRow(item, $event)" v-if="canDelete">
                                <template slot-scope="{ loadingClass }">
                                    <button :class="['redHover', loadingClass]">Удалить</button>
                                </template>
                            </v-loading-component>
                        </div>
                    </td>
                </tr>
            </table>
        </fieldset>
    </form>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        canModify: {
            type: Boolean,
            required: false,
            default: true
        },
        canDelete: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    methods: {
        deleteRow: function (comment, btn) {
            this.$modal('Удалить?', {
                name: 'Да',
                callback: () => {
                    btn.startLoadingAnimation();
                    this.axios.post('directQuestions/delete/' + comment.id).then(() => {
                        this.$emit('update-table');
                        btn.stopLoadingAnimation()
                    }, () => {
                        btn.stopLoadingAnimation()
                    });
                }
            },);
        },
        publish: function (data, btn) {
            this.actionRequest('publish', data,btn).then(() => {this.$emit('update-table');})
        },
        unPublish: function (data, btn) {
            this.actionRequest('unPublish', data,btn).then(() => {this.$emit('update-table');})
        },
        update: function (data, btn) {
                this.actionRequest('update', data,btn);
        },
        actionRequest: function (action,data, btn) {
            btn.startLoadingAnimation();
            return this.axios.post('directQuestions/'+action+'/' + data.id, data).then(() => {
                btn.stopLoadingAnimation()
            }).catch(() => btn.stopLoadingAnimation());
        },
    },

    computed: {
        textareaFilters: function () {
            return "capitalize itemclean striptags typograf";
        }
    }
}
</script>

<style scoped>
table.grid > tr > td {
    border: 5px solid transparent;
}
.direct_question_form__phone{
   display:inline;
    float: right;
    padding-right: 20px;
    padding-top: 4px;
}
input[type='radio'] {
    margin: 0 0 10px 0;
}

.textareaMarkable {
    position: relative;
    overflow: hidden;
}

.textareaMarkable textarea {
    font-size: 16px;
    padding: 3px;
    position: relative;
}

.textareaMarkable div {
    font-size: 16px;
    padding: 4px;
    padding-right: 13px;
    position: absolute;
    top: 0;
    color: transparent;
    height: auto;
    width: 100%;
    pointer-events: none;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.textareaMarkable div mark {
    color: transparent;
}

.inputMarkable {
    position: relative;
    overflow: hidden;
}

.inputMarkable input {
    font-size: 16px;
    position: relative;
}

.inputMarkable div {
    font-size: 16px;
    padding: 1px;
    position: absolute;
    top: 0;
    color: transparent;
    height: 0;
    pointer-events: none;
}

.inputMarkable div mark {
    color: transparent;
}
</style>
